import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import NotFound from "../pages/NotFound";
import PrivateRoute from "../utils/PrivateRoute";
import MainLayout from "../layouts/MainLayout";
import Table from "../pages/table/Table";
import Panchang from "../pages/panchang";
import LaganList from "../pages/lagan";
import NakshtraList from "../pages/nakshatra";
import SamvatList from "../pages/samvat";

const AppRouter = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || token === "null" || token === "undefined") {
      navigate("/login");
    }
  }, [token, navigate]);

  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />

      {/* Private Routes */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/table" element={<Table />} />
          <Route path="/panchang" element={<Panchang />} />
          <Route path="/lagan" element={<LaganList />} />
          <Route path="/nakshtra" element={<NakshtraList />} />
          <Route path="/samvat" element={<SamvatList />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
